import gqlRequest from 'graphql/generic';
import { Permission, Roles } from '../types';

type createRoleReturn = {
  createRole: Roles;
};

export type createRoleParams = {
  description: string;
  permissions: Permission[];
};

const createRolesQuery = `
  mutation Mutation($description: String!, $permissions: [PartyPermissionContent!]) {
    createRole(description: $description, permissions: $permissions) {
      _id
      description
      permissions {
        element
        kind
      }
    }
  }
`;

export const GQLCreateRole = (params: createRoleParams) =>
  gqlRequest<createRoleReturn, createRoleParams>(createRolesQuery, params);

type deleteRoleReturn = {
  deleteRole: {
    _id: string;
  };
};

export type deleteRoleParams = {
  id: string;
};

const deleteRoleQuery = `
  mutation DeleteRole($id: ID!) {
    deleteRole(_id: $id) {
      _id
    }
  }
`;

export const GQLDeleteRole = (params: deleteRoleParams) =>
  gqlRequest<deleteRoleReturn, deleteRoleParams>(deleteRoleQuery, params);

type updateRoleReturn = {
  updateRole: Roles;
};

export type updateRoleParams = {
  id: string;
  description: string;
  permissions: {
    element: string;
    kind: string;
  };
};

const updateRoleQuery = `
  mutation UpdateRole($id: ID!, $description: String!, $permissions: [PartyPermissionContent!]) {
    updateRole(_id: $id, description: $description, permissions: $permissions) {
      _id
      description
      permissions {
        element
        kind
      }
    }
  }
`;

export const GQLUpdateRole = (params: updateRoleParams) =>
  gqlRequest<updateRoleReturn, updateRoleParams>(updateRoleQuery, params);
